export default __webpack_public_path__ + "static/media/BF.3cb0c098.ico";